import { ReactNode } from 'react'
import { FlexBox } from './FlexBox'
import { CardActionArea, SxProps, Typography, useTheme } from '@mui/material'
import { useBetContext } from 'contexts/BetContext'

export const KeyboardButton = ({
    children,
    onClick,
    focused = false,
    disabled = false,
    sx = {},
    textSx = {}
}: {
    children: ReactNode
    onClick?: () => void
    focused?: boolean
    disabled?: boolean
    sx?: SxProps
    textSx?: SxProps
}) => {
    const theme = useTheme()
    const { mainColor } = useBetContext()

    return (
        <CardActionArea
            onClick={() => onClick && onClick()}
            sx={{
                width: '100%',
                borderRadius: theme.spacing(1),
                overflow: 'hidden',
                backgroundColor: focused ? mainColor : '#F4F6FA'
            }}
            disabled={disabled}
        >
            <FlexBox
                sx={{
                    justifyContent: 'center',
                    width: '100%',
                    height: 45,
                    opacity: disabled ? 0.5 : 1,
                    ...sx
                }}
            >
                <Typography
                    variant="title-16-bold"
                    sx={{
                        color: focused ? 'white' : theme.palette.text.secondary,
                        textTransform: 'uppercase',
                        ...textSx
                    }}
                >
                    {children}
                </Typography>
            </FlexBox>
        </CardActionArea>
    )
}
